function q(v: string): string {
  const needs = /[",\n]/.test(v);
  return needs ? `"${v.replace(/"/g, '""')}"` : v;
}

export function toCsv<T extends Record<string, unknown>>(rows: T[], headers: string[]): string {
  const head = headers.join(',');
  const body = rows.map((r) => headers.map((h) => q(String(r[h] ?? ''))).join(',')).join('\n');
  return [head, body].filter(Boolean).join('\n');
}
